import * as Sentry from "@sentry/astro";

Sentry.init({
  // Adds request headers and IP for users, for more info visit:
  // https://docs.sentry.io/platforms/javascript/guides/astro/configuration/options/#sendDefaultPii
  sendDefaultPii: true,

  release: import.meta.env.npm_package_version,
  integrations: [],
  tracesSampleRate: 0,
});
